import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 10px;
  width: 100%;
  margin-bottom: auto;

  img {
    width: 150px;
    height: 45px;
  }
`;
